import React from 'react';
import lodash from 'lodash';
import moment from 'moment';

import Input from "../VaccinationDetailsWrapper/Components/InputForm/index";
import "./VaccinationDetailsContainer.css"

const VaccinationDetailsContainer = ({ name, userVaccineInfo, hideButton = true, vaccinated = false, buttonOnclickhandler = () => { }, hideNameSentence = false, doseNumberFromProps = "", doseNo = null, addOrEditClicked, addClicked }) => {

  const doseNumber = lodash.get(userVaccineInfo, "dose", "");
  const doseName = lodash.get(userVaccineInfo, "name", "");
  const doseDate = lodash.get(userVaccineInfo, "date_of_dose", "");

  const vaccinatedForDose = (doseNumber && doseName && doseDate)

  return (
    <div className="express-interest-question express-interest-first-question">
      {vaccinated && vaccinatedForDose &&
        <div className="vaccine-details-head">
          <div className="vaccine-details-header">
            {(!hideNameSentence) && <div>Hi {name}, these are your vaccination details</div>}
            {(!hideNameSentence) && <br />}
            <div>{`Latest vaccination Dose ${doseNumber} - ${doseName},  administered on ${moment(doseDate).format('Do MMMM YYYY')}`}</div>
          </div>
          <div>
            {(!hideNameSentence) && <br />}
            <Input type="button" value="Edit" addClassInput={`update-vaccine-details-submit-button update-vaccine-details-upload-button vaccine-details-button ${(doseNo == doseNumber && addOrEditClicked) ? "vaccine-details-button-clicked" : ""}`} onClick={() => buttonOnclickhandler(doseNumberFromProps, true)} />
          </div>
        </div>
      }
      {
        vaccinated && !vaccinatedForDose &&
        <div className="vaccine-details-head">
          <div className="vaccine-details-header">
            {(!hideNameSentence) && <div>Hi {name}, these are your vaccination details</div>}
            {(!hideNameSentence) && <br />}
            <div>We do not have your dose {doseNumberFromProps} vaccination information</div>
          </div>
          {(!hideNameSentence) && <br />}
          {(!hideButton) && <Input type="button" value="Add" addClassInput={`update-vaccine-details-submit-button update-vaccine-details-upload-button vaccine-details-button ${(doseNo == doseNumberFromProps && addOrEditClicked) ? "vaccine-details-button-clicked" : ""}`} onClick={() => buttonOnclickhandler(doseNumberFromProps, false)} />}
        </div>
      }
      {!vaccinated &&
        <div className="vaccine-details-head">
          <div className="vaccine-details-header">
            Hi {name} , we do not have your vaccination information
          </div>
          {(!hideButton) && <Input type="button" value="Add" addClassInput={`update-vaccine-details-submit-button update-vaccine-details-upload-button vaccine-details-button ${addClicked ? "vaccine-details-button-clicked" : ""}`} onClick={buttonOnclickhandler} />}
        </div>
      }
    </div>
  );
}

export default VaccinationDetailsContainer;